import { render, staticRenderFns } from "./templates_form.vue?vue&type=template&id=e5c11a20&lang=pug&"
import script from "./templates_form.vue?vue&type=script&setup=true&lang=js&"
export * from "./templates_form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./templates_form.vue?vue&type=style&index=0&id=e5c11a20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports